import { createContext, useContext } from 'react'

export interface AdminContextValue {
  /** True only when the signed-in user has user_profiles.is_super_admin = true. */
  isAdmin: boolean
  /**
   * True until the first lookup completes. Components should hide admin
   * affordances during loading rather than flicker them in then out.
   */
  loading: boolean
}

export const AdminContext = createContext<AdminContextValue | null>(null)

/**
 * Read the cached super-admin flag. Throws if used outside <AdminProvider>
 * so we never silently render admin UI based on the default false.
 */
export function useIsAdmin(): AdminContextValue {
  const ctx = useContext(AdminContext)
  if (!ctx) {
    throw new Error('useIsAdmin must be used inside <AdminProvider>')
  }
  return ctx
}
